import { render, staticRenderFns } from "./ShippedHistory.vue?vue&type=template&id=1d7d6fc1"
import script from "./ShippedHistory.vue?vue&type=script&lang=js"
export * from "./ShippedHistory.vue?vue&type=script&lang=js"
import style0 from "./ShippedHistory.vue?vue&type=style&index=0&id=1d7d6fc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports